<div class="login-page">
    <div class="card card-outline card-danger" style="width:100% ;height:100%">
            <div class="login-logo">
                <a>Welcome to <b>DMK Engineers Wing</b> Portal</a>
                  <div><img src="assets/dmk.png" alt="Logo" class="" style="opacity: .8;width: 120px;">
                  </div>
                  <!-- <div [hidden]="content_hidden">
                    <h2 class="my-3">This page has been expired</h2>
                  <a [routerLink]="['']" style="margin:auto" class="btn btn-block btn-danger col-3 text-white">Back to Login</a>
                  </div> -->
            </div>
            <div class="card-body login-card-body" [hidden]="form_hidden">
              <form [formGroup]="checkpassword" (ngSubmit)="postdata(checkpassword)">
                <div class="row ml-4 text-center justify-content-center"> <!-- Add text-center class here -->
                  <div class="col-md-6 offset-md-2"> <!-- Center the form within a column -->
                    <div class="form-group row col-sm-8">                        
                      <label>Old Password</label>
                      <input type="password" (focusout)="checkoldpassword()" name="password" formControlName="oldPassword" class="form-control">
                    <p *ngIf="!submitpassword" class="text-danger">Old password is not match with you current password</p>
                    </div>
                    <div class="form-group row col-sm-8">
                      <label>New Password</label>
                      <input type="password" name="password" formControlName="password" class="form-control">
                    </div>
                    <div class="form-group row col-sm-8">
                      <label>Confirm Password</label>
                      <input type="password" (focusout)="checknewpassword()" formControlName="cpassword" name="cpassword" class="form-control">
                      <p *ngIf="!submitnewpassword" class="text-danger">Your confirmation password doesn't match with new password</p>
                    </div>
                  </div>
                </div>
                <div class="ml-6 text-center"> <!-- Center-align the button as well -->
                  <button class="btn btn-danger" >Submit</button>
                </div>
              </form>
            </div>
            
    </div>
    </div>